{
  "name": "31-Vicentino I (1555) 1/4 Comma (g♭-a♯♯♯)",
  "description": "31-tone scale in extended 1/4 Comma meantone (probably the tuning used for Nicola Vicentino’s instruments, following his description). Each fifth in the range g♭-a♯♯♯ is narrowed from its JI ratio 2:3 by 1/4 of a Syntonic Comma, so that four successive fifths produce a major third 4:5. Standard 12-tone meantone usually ranges from e♭ to g♯, leaving a so-called \"wolf\" fifth. By extending the tuning to 31 notes, a circulating well-temperament is produced: the missing c may be replaced by the enharmonically nearly-equivalent pitch b. Note that b *is* equivalent to c!",
  "scale": [
    "34.99014086",
    "76.04899926",
    "117.1078577",
    "152.0979985",
    "193.1568569",
    "228.1469978",
    "269.2058562",
    "310.2647146",
    "345.2548555",
    "386.3137139",
    "421.3038547",
    "462.3627131",
    "503.4215715",
    "538.4117124",
    "579.4705708",
    "620.5294292",
    "655.5195701",
    "696.5784285",
    "731.5685693",
    "772.6274277",
    "813.6862861",
    "848.676427",
    "889.7352854",
    "924.7254263",
    "965.7842847",
    "1006.843143",
    "1041.833284",
    "1082.892142",
    "1117.882283",
    "1158.941142",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "31-MT_VicentinoI",
  "built_in_group": "Extended Meantone",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "c",
    "c",
    "d",
    "d",
    "d",
    "d",
    "d",
    "e",
    "e",
    "e",
    "e",
    "e",
    "f",
    "f",
    "f",
    "g",
    "g",
    "g",
    "g",
    "g",
    "a",
    "a",
    "a",
    "a",
    "a",
    "b",
    "b",
    "b",
    "b",
    "b"
  ],
  "note_colors": [
    "#ffcfcf",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#e2dfcf",
    "#eee9d3",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#e2dfcf",
    "#eee9d3"
  ],
  "equivSteps": 31,
  "fundamental": 440,
  "reference_degree": 23,
  "center_degree": 0,
  "rSteps": 5,
  "drSteps": 3,
  "hexSize": 42,
  "rotation": -16.102113751
}
